import { Box, CircularProgress, Typography } from "@mui/material";
import { useEffect, useRef } from "react";
import { performOakSignOut } from "utils/performOakSignOut";

/**
 * Entry point for Knowledge (and other apps) to trigger Oak sign-out via redirect.
 * GET /auth/logout — clears Amplify session, then lands on Oak `/`.
 */
export function OakAuthLogout() {
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) {
      return;
    }
    startedRef.current = true;
    void performOakSignOut({ redirectTo: "/" });
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "40vh",
        gap: 2,
      }}
    >
      <CircularProgress size={32} />
      <Typography color="text.secondary">Signing out…</Typography>
    </Box>
  );
}
